/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import Modal from 'react-modal'
import moment from 'moment'
import * as Yup from 'yup'

import { FiUser, FiX, FiCheck, FiTrash2 } from 'react-icons/fi'
import { MdSecurity } from 'react-icons/md'

import { BiCake } from 'react-icons/bi'
import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import validaCPF from '../../utils/validaCPF'

import InputSelect from '../../components/InputSelect'
import InputHidden from '../../components/InputHidden'
import Header from '../../components/Header'
import Button from '../../components/Button'
import Input from '../../components/Input'

import {
  Container,
  Content,
  BtnVoltar,
  Line,
  BenefBox,
  ContentBenef,
  BtnModal,
} from './styles'
import {
  UserData,
  Participant,
  ParticipantDetails,
  UserAddress,
} from '../../utils/interfaces'
import calculaIdade from '../../utils/calculaIdade'
import { useLeadLovers } from '../../hooks/mectrics'
import ModalBox from '../../components/Modal'

Modal.setAppElement('#root')

const Beneficiary: React.FC = () => {
  const leadLovers = useLeadLovers()
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [userDetails] = usePersistedState<ParticipantDetails>(
    'userDetails',
    {} as ParticipantDetails,
  )

  const [participants, setParticipants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [userAddress] = usePersistedState<UserAddress>(
    'userAddress',
    {} as UserAddress,
  )
  const [, setSaveAndAddNew] = useState(false)
  const [tipoBenef] = useState('2')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal, setTxtModal] = useState('')

  const [thisParticipantData] = useState<UserData>({} as UserData)
  const [thisParticipantDetails] = useState<ParticipantDetails>(
    {} as ParticipantDetails,
  )
  const [thisParticipant, setThisParticipant] = useState<Participant>(
    {} as Participant,
  )

  const [grauParent, setGrauParent] = useState({
    label: userDetails.dcrGrauParentesco,
    value: userDetails.grauParentesco,
  })

  const formRef = useRef<FormHandles>(null)
  const history = useHistory()
  const location = useLocation()

  // const [dtNasc, setDtNasc] = useState('')

  const handleAddNovo = useCallback(() => {
    setSaveAndAddNew(true)
    const field = formRef.current?.getFieldRef('addNew')
    field.value = true
    formRef.current?.submitForm()
  }, [])

  const handleJustSave = useCallback(() => {
    setSaveAndAddNew(false)
    const field = formRef.current?.getFieldRef('addNew')
    field.value = false
    formRef.current?.submitForm()
  }, [])

  useEffect(() => {
    const leadData = {
      Email: userData.email,
      city: userAddress.municipio,
      state: userAddress.uf,
      Notes: 'Última página: Beneficiários',
    }

    leadLovers.put(leadData)
  }, [])

  const handleChangeGrauParentesco = useCallback(e => {
    const t = e
    setGrauParent(t)
  }, [])

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleRemove = useCallback(
    id => {
      setParticipants(() =>
        participants.filter((participant, idx) => idx !== id),
      )
    },
    [participants, setParticipants],
  )

  useEffect(() => {
    const benefBox = document.getElementById('benefBox') as HTMLDivElement
    const altura = benefBox.clientHeight
    window.scrollTo({
      top: altura,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  const handleSubmit = useCallback(
    async formData => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          name: Yup.string()
            .required('Campo obrigatório.')
            .matches(/\s/g, 'Digite o nome completo')
            .min(3, 'Digite o nome completo'),
          birthdate: Yup.string()
            .required('Campo obrigatório.')
            .min(10, 'Data de nascimento deve seguir o formato dd/mm/aaaa.')
            .test(
              '',
              'A data de nascimento não pode ser maior que hoje.',
              () =>
                moment() >
                  moment(formData.birthdate.split('/').reverse().join('-')) ||
                formData.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                moment(
                  formData.birthdate.split('/').reverse().join('-'),
                ).isValid() || formData.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                calculaIdade(
                  formData.birthdate.split('/').reverse().join('-'),
                ) <= 115 || formData.birthdate === '',
            ),
          cpf: Yup.string()
            .required('Campo obrigatório.')
            .test('', 'CPF já utilizado em outro cadastro', function v() {
              const t2 =
                (participants.filter(
                  participant => participant.data.cpf === formData.cpf,
                ).length <= 0 &&
                  formData.cpf !== userData.cpf) ||
                formData.cpf === ''
              return t2
            })
            .test('', 'CPF inválido', function t() {
              const teste =
                validaCPF(formData.cpf.replaceAll('.', '').replace('-', '')) ||
                formData.cpf === ''
              return teste
            }),
          grauParentesco: Yup.string()
            .required('Campo obrigatório')
            .test(
              '',
              'Outro beneficiário já foi cadastrado como cônjuge',
              () => {
                const conjugeExiste =
                  participants.filter(
                    participant => participant.details.grauParentesco === '1',
                  ).length > 0
                return (
                  !conjugeExiste ||
                  (conjugeExiste && formData.grauParentesco !== '1')
                )
              },
            ),
          // proporcao: Yup.string().required('Campo obrigatório'),
        })

        await schema.validate(formData, { abortEarly: false })

        const aa = formData.birthdate
        const dia = aa.split('/')[0]
        const mes = aa.split('/')[1]
        const ano = aa.split('/')[2]
        const dataForm = `${ano}-${`0${mes}`.slice(-2)}-${`0${dia}`.slice(-2)}`

        setThisParticipant({
          ...thisParticipant,
          data: {
            ...thisParticipantData,
            name: formData.name,
            cpf: formData.cpf,
            birthdate: formData.birthdate === '' ? '' : dataForm,
          },
          details: {
            ...thisParticipantDetails,
            tipoBen: tipoBenef,
            grauParentesco: grauParent.value,
            dcrGrauParentesco: grauParent.label,
          },
        })

        setParticipants([
          ...participants,
          {
            ...thisParticipant,
            data: {
              ...thisParticipantData,
              name: formData.name,
              cpf: formData.cpf,
              birthdate: formData.birthdate === '' ? '' : dataForm,
            },
            details: {
              ...thisParticipantDetails,
              tipoBen: tipoBenef,
              grauParentesco: grauParent.value,
              dcrGrauParentesco: grauParent.label,
            },
          },
        ])
        if (formData.addNew === 'true') {
          history.push(`${location.pathname}`)
          formRef.current?.reset()
        } else {
          history.push('/participants-list')
        }
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err))
      }
    },
    [
      grauParent,
      history,
      location.pathname,
      participants,
      setParticipants,
      thisParticipant,
      thisParticipantData,
      thisParticipantDetails,
      tipoBenef,
      userData,
    ],
  )

  const arr = participants.map(participant => participant.details.proporcao)
  let soma = 0
  for (let i = 0; i < arr.length; i += 1) {
    soma += arr[i]
  }
  // const handleValidaProporcao = useCallback((prop, s) => {
  //   if (prop < 1 || prop > s) {
  //     const msg = `A proporção deve ser maior que 1 e menor que ${s}`
  //     // eslint-disable-next-line no-alert
  //     alert(msg)
  //   } else {
  //     setVlrProporcao(prop)
  //   }
  // }, [])

  return (
    <>
      <Header />
      <Container>
        <div id="benefBox" style={{ width: '100%' }}>
          {participants.length > 0 ? (
            <BenefBox>
              <h3>Beneficiários</h3>
              {participants.map((participant, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <ContentBenef key={index}>
                  <div>
                    <FiTrash2 onClick={() => handleRemove(index)} />
                    <div>
                      <small>
                        {`${index + 1} - Beneficiário ${
                          participant.details.tipoBen === '1' ? 'Indicado' : ''
                        }`}
                      </small>
                    </div>
                    <div>
                      <strong>Nome: </strong>
                      <label>{participant.data.name}</label>
                    </div>
                    <div>
                      <strong>Idade: </strong>
                      <label>
                        {calculaIdade(participant.data.birthdate)} anos
                      </label>
                    </div>
                    <div>
                      <strong>CPF: </strong>
                      <label>{participant.data.cpf}</label>
                    </div>
                    <div>
                      <strong>Parentesco: </strong>
                      <label>{participant.details.dcrGrauParentesco}</label>
                    </div>
                  </div>
                  <Line />
                </ContentBenef>
              ))}
            </BenefBox>
          ) : null}
        </div>

        <Content>
          <strong>Informe os dados do beneficiário:</strong>
          <p>
            Os beneficiários são de livre designação e podem ser alterados pelo
            participante a qualquer tempo.
          </p>
          <Form
            ref={formRef}
            onSubmit={handleSubmit}
            initialData={{
              name: thisParticipantData.name,
              cpf: thisParticipantData.cpf,
              birthdate:
                thisParticipantData.birthdate === undefined
                  ? ''
                  : thisParticipantData.birthdate
                      .split('-')
                      .reverse()
                      .join('/'),
              grauParentesco: grauParent.value,
              dcrGrauParentesco: grauParent.label,
            }}
          >
            <InputHidden name="addNew" type="hidden" />
            <InputHidden name="contribution" type="hidden" />
            <InputHidden name="years" type="hidden" />

            <InputSelect
              name="grauParentesco"
              value={grauParent}
              options={[
                { label: 'Cônjuge', value: '1' },
                { label: 'Companheiro(a)', value: '2' },
                {
                  label: 'Filho(a) não emancipado menor de 21 anos',
                  value: '3',
                },
                { label: 'Filho(a) inválido(a)', value: '4' },
                { label: 'Pai/mãe', value: '5' },
                { label: 'Mãe inválida', value: '13' },
                {
                  label:
                    'Irmã(o) não emancipada(o) menor de 21 anos com dependência econômica',
                  value: '6',
                },
                {
                  label: 'Irmã(o) inválida(o) com dependência econômica',
                  value: '7',
                },
                {
                  label:
                    'Enteado(a) não emancipado(a) menor de 21 anos com dependência econômica',
                  value: '8',
                },
                {
                  label: 'Enteado(a) inválido(a) com dependência econômica',
                  value: '9',
                },
                {
                  label:
                    'Menor tutelado não emancipado menor de 21 anos com dependência econômica',
                  value: '10',
                },
                {
                  label: 'Menor tutelado inválido com dependência econômica',
                  value: '11',
                },
                { label: 'Filho(a) maior de 21 anos', value: '12' },
                { label: 'Sobrinho', value: '14' },
                { label: 'Outros', value: '0' },
              ]}
              placeholder="Parentesco"
              onChange={e => handleChangeGrauParentesco(e)}
            />
            <Input placeholder="Nome completo" name="name" icon={FiUser} />
            <Input
              placeholder="CPF"
              name="cpf"
              id="cpf"
              icon={MdSecurity}
              type="tel"
              mask="cpf"
              required
            />
            {/* <Input
              icon={FiCalendar}
              name="birthdate"
              value={dtNasc}
              placeholder="Data de nascimento"
              min="1930-01-01"
              max={new Date().toISOString().split('T')[0]}
              onChange={e => handleOnChange(e)}
              onKeyDown={e => handleOnKeyDown(e)}
            /> */}
            <Input
              icon={BiCake}
              name="birthdate"
              placeholder="Data de nascimento"
              mask="date"
            />
          </Form>
          <Button type="button" fontSize="small" onClick={handleAddNovo}>
            Adicionar mais um beneficiário
          </Button>
        </Content>

        <Button
          type="button"
          fontSize="normal"
          color="blue"
          width="large"
          onClick={handleJustSave}
        >
          <FiCheck size={45} />
          <span>Confirmar dados</span>
        </Button>

        {participants.length > 0 ? (
          <Button
            type="button"
            fontSize="normal"
            onClick={() => history.push('/participants-list')}
            color="white"
          >
            Pronto! Avançar
          </Button>
        ) : (
          <Button
            type="button"
            fontSize="normal"
            onClick={() => history.push('/ppe-fatca')}
            color="red"
          >
            Informar depois
          </Button>
        )}

        <BtnVoltar type="button" onClick={() => history.push('address-infos')}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Beneficiary
